import { useEntity } from './entities/useEntity';
import { CRM } from '../constants/integrations';

const useSalesforce = () => {
  const salesforceIntegration = useEntity('integrationSalesforces')?.all()[0];

  return {
    salesforceIntegration: {
      ...salesforceIntegration,
      type: CRM.SALESFORCE,
      active: !!salesforceIntegration,
    },
  };
};

export default useSalesforce;
